import styled, { css } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScDescriptionContainer = styled.div<{ isExpanded: boolean }>`
  position: relative;
  max-height: 280px;
  height: 100%;
  overflow-y: hidden;
  padding-bottom: 32px;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      max-height: initial;
      padding-bottom: 64px;
    `}
`;

export const ScDescriptionAction = styled.div<{ isExpanded: boolean }>`
  position: absolute;
  bottom: 0px;

  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 80px;
  width: 100%;

  ${({ isExpanded, theme }) =>
    !isExpanded &&
    css`
      background: ${theme.blackGradient};
    `}
`;

export const ScDescriptionText = styled.div`
  * > * {
    color: ${({ theme }) => theme.white};
  }

  h1 {
    margin: 0.75em 0;
    ${typography['headline2']}
    @media (${device.mobile}) {
      ${typography['headline2mobile']}
    }
  }
  h2 {
    margin: 0.83em 0;
  }
  h3 {
    margin: 1.17em 0;
  }
  h4 {
    margin: 1.33em 0;
  }
  h5 {
    margin: 1.67em 0;
  }
  h6 {
    margin: 2.33em 0;
  }
  p {
    margin: 1em 0;
  }

  p,
  td,
  th {
    color: ${({ theme }) => theme.white};
  }

  ul {
    list-style-type: disc;
  }

  ul,
  ol {
    margin: 0 32px;
    li {
      margin: 0px !important;
    }
  }
`;
